/**
 * storeRef — circular import sorunu olmadan apiClient katmanından Redux
 * store'a erişim sağlar. main.jsx'te store oluştuktan hemen sonra
 * initStoreRef(store) çağrılır.
 */
let _store = null;

export const initStoreRef = (store) => { _store = store; };
export const getStore = () => _store;
